import {
  FETCH_PAYMENTS,
  FETCH_PAYMENT,
  CREATE_PAYMENT,
  UPDATE_PAYMENT,
  DELETE_PAYMENT,
  FETCH_PAYMENTS_BY_INVOICE,
  FETCH_PAYMENTS_BY_PAYROLL,
  FETCH_PAYMENTS_BY_RENTAL,
  PRINT_PAYMENT_RECEIPT,
} from "../actions/constants";

const initialState = {
  payments: [],
  payment: null,
  currentPage: 1,
  numberOfPages: 1,
  isLoading: false,
  error: null,
  receiptBlob: null,
};

const paymentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PAYMENTS:
      return {
        ...state,
        payments: action.payload.payments,
        currentPage: action.payload.data?.pagination?.currentPage || 1,
        numberOfPages: action.payload.data?.pagination?.totalPages || 1,
        isLoading: false,
        error: null,
      };

    case FETCH_PAYMENT:
      return {
        ...state,
        payment: action.payload,
        isLoading: false,
        error: null,
      };

    case CREATE_PAYMENT:
      return {
        ...state,
        payments: [...state.payments, action.payload],
        isLoading: false,
        error: null,
      };

    case UPDATE_PAYMENT:
      return {
        ...state,
        payments: state.payments.map((payment) =>
          payment._id === action.payload._id ? action.payload : payment
        ),
        isLoading: false,
        error: null,
      };

    case DELETE_PAYMENT:
      return {
        ...state,
        payments: state.payments.filter(
          (payment) => payment._id !== action.payload
        ),
        isLoading: false,
        error: null,
      };

    case FETCH_PAYMENTS_BY_INVOICE:
    case FETCH_PAYMENTS_BY_PAYROLL:
    case FETCH_PAYMENTS_BY_RENTAL:
      return {
        ...state,
        payments: action.payload,
        isLoading: false,
        error: null,
      };

    case PRINT_PAYMENT_RECEIPT:
      return {
        ...state,
        receiptBlob: action.payload,
        isLoading: false,
        error: null,
      };

    default:
      return state;
  }
};

export default paymentsReducer;
